module.exports = __webpack_public_path__ + "img/partyterminal3.3396afaa.png";